import {Tabs, Tooltip } from "antd";
import React, { FC, useState } from "react";
import * as XLSX from 'xlsx';

import AppointmentInfo from "../AppointmentInfo/AppointmentInfo";
import ARSummary from "../ARSummary/ARSummary";
import DownloadReport from "@assets/DownloadReport.svg";
import "./drillDownViewTable.scss";
import { forEach } from "lodash";

const DrillDownViewTable: FC<any> = ({ appointmentInfoLoading, activeTabKey, callback, patientDayAppointmentDetails }) => {
  const { TabPane } = Tabs;
  const [arReportAppointmentDetails, setArReportAppointmentDetails] = useState();
  let columnWithDollorFormat = ["CURRENT", "OVER 30", "OVER 60", "OVER 90", "OVER 120", "OVER 180", "OVER 270", "OVER 360", "TOTAL AR", "APPOINTMENT AMOUNT"];

  const tabsConfig = {
    "Appointment Info": true,
    "AR Summary": true,
  };

  const onTabChange = (key: any) => {
    callback(key);
  };

  const generateReport = () => {
    let data:any;
    let fileName="";
    if(activeTabKey===1){ data=patientDayAppointmentDetails;fileName="Patient Appointment Information"}
    else {data=arReportAppointmentDetails; fileName="Patient AR Summary"}

    let reportObj:any = [];
    forEach(data , (item)=>{
      let tempObject:any = {}
      forEach(item, (itemEntries)=>{
        tempObject[columnWithDollorFormat.includes(itemEntries.label) ? `${itemEntries.label} (in US Dollars)` : itemEntries.label]=columnWithDollorFormat.includes(itemEntries.label)? Number(itemEntries.value) : 
        (itemEntries.label.includes("%")?itemEntries.value+"%" : itemEntries.value);
      })
      reportObj.push(tempObject);
    })
    if(reportObj.length > 0){
      const fileLabel = `${fileName}.xlsx`;
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(reportObj);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, fileName);
      XLSX.writeFile(wb, fileLabel);
    }
  }

  const operations = (
    <Tooltip title="Download XLS" overlayClassName="download-tooltip" className="downloadReportForPatient">
      <img alt="" src={DownloadReport} className="downloadReportForPatient__downloadIcon" onClick={generateReport}/>
    </Tooltip>
  );

  return (
    <div className="dayViewAppointmentReports">
      <Tabs activeKey={activeTabKey} defaultActiveKey="1" className="tab-menu" onChange={onTabChange} tabBarExtraContent={operations}>
        {tabsConfig["Appointment Info"] && (
          <TabPane tab={`Appointment Info`} key="1">
            <AppointmentInfo appointmentInfoLoading={appointmentInfoLoading} patientDayAppointmentDetails={patientDayAppointmentDetails} />
          </TabPane>
        )}
        {tabsConfig["AR Summary"] && (
          <TabPane tab={`AR Summary`} key="2">
            <ARSummary setArReportAppointmentDetails={setArReportAppointmentDetails}/>
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default DrillDownViewTable;
